function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eb832ef1-460e-4713-9e95-c2e54fc21213{fill:none;stroke:#f65e5c;stroke-width:10.04px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b3fd6a94-6ef5-4077-9458-60b0d9284bce",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "ebbb63e7-5b0d-4bc7-bd5e-497ce3d4f298",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "eb832ef1-460e-4713-9e95-c2e54fc21213",
  points: "111.35 246.42 6.65 125.72 111.35 5.02 159.05 5.02 56.35 125.72 159.05 246.42 111.35 246.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "eb832ef1-460e-4713-9e95-c2e54fc21213",
  points: "214.35 246.42 109.65 125.72 214.35 5.02 262.05 5.02 159.35 125.72 262.05 246.42 214.35 246.42"
})));

var SvgLogoIcon6 = function SvgLogoIcon6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 272.91 251.44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (6).b176ba43.svg";
export { ForwardRef as ReactComponent };